import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PermissionSettingRepositoryService extends BaseRepositoryService<
  ModelRegistry['permission-setting']
> {
  recordName = 'permission-setting';
  implementMethods = ['query', 'save', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/permission-setting': PermissionSettingRepositoryService;
  }
}
